import { httpBatchLink, loggerLink } from '@trpc/client';
import type { TRPCClient } from '@trpc/client';
import type { AppRouter } from '@org/school-server/src/index';
import type { QueryClient } from '@tanstack/react-query';
import { createTRPCReact } from '@trpc/react-query';
import superjson from 'superjson';
import { createContext } from 'react';
import { sentryLink } from '../lib/sentry-link';

export const TrpcContext = createContext(null);
export const trpc = createTRPCReact<AppRouter>({ context: TrpcContext });

export interface CreateClientOptions {
  queryClient: QueryClient;
  getAccessToken: () => Promise<string>;
  /** Extra headers attached to every request (e.g. admin impersonation). */
  getExtraHeaders?: () => Record<string, string>;
  apiUrl?: string;
  transformer?: typeof superjson;
}

export const createTrpcClient = ({
  queryClient,
  getAccessToken,
  getExtraHeaders,
  apiUrl = 'http://localhost:3333/api',
  transformer = superjson,
}: CreateClientOptions): TRPCClient<AppRouter> => {
  return trpc.createClient({
    // @ts-ignore
    transformer,
    links: [
      loggerLink({
        enabled: (opts) =>
          process.env.NODE_ENV === 'development' &&
          // @ts-ignore
          (typeof window !== 'undefined' ? true : opts.direction === 'down'),
      }),
      sentryLink<AppRouter>({ source: 'school' }),
      httpBatchLink({
        url: apiUrl,
        // @ts-ignore
        transformer,
        async headers() {
          const extra = getExtraHeaders?.() ?? {};
          try {
            const token = await getAccessToken();
            return {
              ...extra,
              Authorization: `Bearer ${token}`,
            };
          } catch (error) {
            console.error('Failed to get access token for tRPC request', error);
            return extra;
          }
        },
      }),
    ],
  });
};
